export default function Logo({ variant = "dark", className = "" }) {
  return (
    <span
      className={`inline-flex items-center rounded-lg bg-[#FDFDFD] px-3 py-2 shadow-[0_2px_16px_rgba(0,0,0,0.35)] ${className}`}
      data-testid="navbar-brand-logo"
    >
      <img
        src={variant === "dark" ? "/aeris_logo.png" : "/aeris_logo_dark.png"}
        alt="Aeris India Technology"
        className="h-8 w-auto select-none md:h-9"
        draggable="false"
      />
    </span>
  );
}
